export const formatReward = (input: number | string) => {
  // Приводим к строке для стабильности
  let value = typeof input === 'number' ? input.toString() : input;

  // Убираем scientific notation (1e-7 → 0.0000001)
  value = Number(value).toFixed(12);

  // Разбиваем число
  const [integer, decimalRaw = ''] = value.split('.');

  // 1) Обрезаем дробную часть до 8 знаков
  let decimal = decimalRaw.slice(0, 8);

  // 2) Убираем нули справа
  decimal = decimal.replace(/0+$/, '');

  // 3) Определяем, есть ли дробная часть
  const hasDecimal = decimal.length > 0;

  // 4) Форматируем целую часть с тысячными разделителями
  const formattedInteger = Number(integer).toLocaleString('en-US');

  // 5) Собираем итоговое значение
  const formatted = hasDecimal ? `${formattedInteger}.${decimal}` : formattedInteger;

  return {
    formatted,
    integer: formattedInteger,
    decimal: hasDecimal ? decimal : null,
  };
};
